import { useCallback } from 'react';
import Tooltip from '@ingka/tooltip';
import Button from '@ingka/button';
import { useDispatch } from 'react-redux';
import type { TreePanes } from '../../store/slices/pane';
import { toggleActivePane } from '../../store/slices/pane';
import Expand from '@ingka/ssr-icon/paths/expand';
import Contract from '@ingka/ssr-icon/paths/contract';
import type { AppThunkDispatch } from '../../store';

const ExpandToggler = function ExpandToggler({
  checked,
  pane,
}: {
  checked: boolean;
  pane: TreePanes;
}) {
  const dispatch = useDispatch<AppThunkDispatch>();
  const toggleSizeAction = useCallback(
    () => dispatch(toggleActivePane(pane)),
    [dispatch, pane],
  );
  return (
    <Tooltip
      describedById="expand-pane-tooltip"
      interactiveCustomTrigger
      position="bottom"
      tooltipText={checked ? 'Contract pane' : 'Expand pane'}
    >
      <Button
        ssrIcon={checked ? Contract : Expand}
        onClick={toggleSizeAction}
        iconOnly
        type="tertiary"
        size="small"
        aria-label={checked ? 'Contract pane' : 'Expand pane'}
      />
    </Tooltip>
  );
};

export default ExpandToggler;
